// Mock data para WCOM Digital

import wcomticketImage from '../assets/images/wamberto/wcomticket-compra.png';

export const companyInfo = {
  name: "WCOM Digital",
  tagline: "Vantagens competitivas para a sua Empresa",
  description: "Acreditamos na Tecnologia da Informação como patrimônio estratégico das Organizações.",
  phone: "21 992575060",
  email: "contato@wcom.digital",
  address: "Rua Ferreira de Andrade, 344/1103 - Rio de Janeiro - RJ"
};

export const services = [
  {
    id: 1,
    title: "Consultoria",
    description: "Realizamos análise dos objetivos estratégicos da sua empresa, elaborando diagnósticos e recomendações, visando aliar a Tecnologia da Informação como instrumento para obtenção de produtividade e resultados de processos.",
    icon: "Lightbulb"
  },
  {
    id: 2,
    title: "Desenvolvimento",
    description: "Utilizamos as tecnologias de última geração para desenvolver softwares, sites e aplicativos, focando em produtividade e qualidade dos serviços prestados.",
    icon: "Code"
  },
  {
    id: 3,
    title: "Marketing Digital",
    description: "Aliamos nossa experiência para atingirmos os melhores resultados em marketing digital, colocando o seu negócio onde ele deve estar, no topo da lista.",
    icon: "TrendingUp"
  },
  {
    id: 4,
    title: "Tecnologia",
    description: "Somos amantes de Tecnologia. Por isso, investimos nossos recursos no aprimoramento de nossas habilidades, a fim de que possamos atendê-lo cada vez melhor.",
    icon: "Cpu"
  }
];

export const projects = [
  {
    id: 1,
    title: "GEDUCA",
    client: "Gestão Educacional Municipal",
    image: "https://wcom.digital/images/img5.jpg",
    category: "Educação"
  },
  {
    id: 2,
    title: "WCOMPass",
    client: "Gestão de Transporte Condominial",
    image: "https://wcompass.com.br/img/wcompass.jpg",
    category: "Transporte"
  },
  {
    id: 3,
    title: "WCOMTicket",
    client: "Bilhetagem Eletrônica e Mobilidade",
    image: "https://wcom.digital/images/wcomticket.jpg",
    category: "Mobilidade"
  },
  {
    id: 4,
    title: "EcoPasse",
    client: "Ecobalsas RJ",
    image: "https://wcom.digital/images/ecobalsas.png",
    category: "Mobilidade"
  },
  {
    id: 5,
    title: "Mapa de Merenda Escolar",
    client: "Cabo Frio",
    image: "https://wcom.digital/images/img1.jpg",
    category: "Gestão Pública"
  },
  {
    id: 6,
    title: "Sistema de Transporte Escolar",
    client: "Cabo Frio",
    image: "https://wcom.digital/images/transporte.jpg",
    category: "Transporte"
  }
];

export const stats = [
  { value: "30+", label: "Anos de Experiência" },
  { value: "300+", label: "Projetos Entregues" },
  { value: "50+", label: "Clientes Satisfeitos" },
  { value: "99%", label: "Taxa de Sucesso" }
];

export const values = [
  {
    title: "Qualidade",
    description: "Entregamos soluções com os mais altos padrões de qualidade",
    icon: "Shield"
  },
  {
    title: "Comprometimento",
    description: "Trabalhamos com dedicação total aos objetivos do cliente",
    icon: "Target"
  },
  {
    title: "Inovação",
    description: "Utilizamos tecnologias de ponta em todos os projetos",
    icon: "Sparkles"
  },
  {
    title: "Parceria",
    description: "Construímos relacionamentos duradouros com nossos clientes",
    icon: "Handshake"
  }
];

export const ceo = {
  name: "Wamberto de Farias",
  role: "CEO & Fundador",
  bio: "Profissional com mais de 30 anos de experiência em Desenvolvimento de software e condução de projetos focados em Tecnologia da Informação e liderança de equipes. Nos últimos anos se especializou em Gestão Educacional e vem conduzindo projetos inovadores na área governamental.",
  image: "https://wcom.digital/images/wamberto.jpg?w=400"
};

export const quotes = [
  {
    text: "Chave de sucesso nos negócios: perceber para onde o mundo está indo e chegar lá primeiro",
    author: "Bill Gates"
  },
  {
    text: "Acreditamos na colaboração mútua entre fornecedores e clientes. O sucesso de nosso cliente e parceiro é o nosso sucesso",
    author: "WCOM Digital"
  }
];
